import { CountryWithStateAndCityOutputCityData } from './country-with-state-and-city-output-city-data.model';


export class CountryWithStateAndCityOutputStateData implements ICountryWithStateAndCityOutputStateData {
    /** The auto-generated id of the state master */
    state_id!: number;
    /** The state name with 255 character limit */
    state_name!: string;
    city!: CountryWithStateAndCityOutputCityData[];

    constructor(data?: ICountryWithStateAndCityOutputStateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state_id = _data["state_id"];
            this.state_name = _data["state_name"];
            if (Array.isArray(_data["city"])) {
                this.city = [] as any;
                for (let item of _data["city"])
                    this.city!.push(CountryWithStateAndCityOutputCityData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryWithStateAndCityOutputStateData {
        data = typeof data === 'object' ? data : {};
        let result = new CountryWithStateAndCityOutputStateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state_id"] = this.state_id;
        data["state_name"] = this.state_name;
        if (Array.isArray(this.city)) {
            data["city"] = [];
            for (let item of this.city)
                data["city"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICountryWithStateAndCityOutputStateData {
    /** The auto-generated id of the state master */
    state_id: number;
    /** The state name with 255 character limit */
    state_name: string;
    city: CountryWithStateAndCityOutputCityData[];
}

